import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pedido/annadirPrevision`, method: 'POST', body: values, token: token})
}
